<template>
  <div class="credit-card">
    <div class="image-container">
      <img class="image-intro" :src="require('@/assets/subscription/flow.png')">
    </div>

    <div class="form">
      <div class="sub-title">נמשיך עם פרטי הכרטיס שממנו יתבצע החיוב לשירות</div>
      <div class="card">
        <div class="body">
          <personal-info-summary/>
          <promo-notification-box />
          <credit-card-details-form />
          <check-card-promo-eligibility />
        </div>

        <div class="separator"></div>
        <div class="body">
          <div class="amount-title">סה״כ לתשלום לכל חודש</div>
          <div class="amount">45 ₪</div>
          <div class="button-container" v-if="!tokenizationError">
            <riseup-button title="לתשלום מאובטח" :action="next" :loading="loadingToken" :disabled="loadingToken"/>
            <div class="disclaimer">{{ firstBillingDateMessage }}</div>
          </div>
          <div class="result-container" v-else>
            <div class="top">
              <div class="icon">
                <img class="icon" :src="require('@/assets/icons/alert-icon.svg')">
              </div>
              <div class="message">
                לא הצלחנו לחייב את הכרטיס
              </div>
            </div>
            <div class="cta">
              אפשר לרענן את העמוד ולנסות להשתמש בכרטיס אחר.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="link" v-on:click="() => back()">חזרה לפרטים האישיים שלך</div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';

import CardNumberField from '../components/credit-card-fields/CardNumber.vue';
import ExpirationField from '../components/credit-card-fields/Expiration.vue';
import CvvField from '../components/credit-card-fields/CVV.vue';
import SocialId from '../components/credit-card-fields/SocialId.vue';
import PersonalInfoSummary from '../components/PersonalInfoSummary.vue';
import Segment from '../../../../../Segment';
import CreditCardDetailsForm from '../../navigation-pages/account-settings/components/CreditCardDetailsForm.vue';
import PaymeInterface from '../../../../../Payme';
import dates from '../../../../../utils/dates';
import PromoNotificationBox from '../../../../../base-components/discount-promotion/PromoNotificationBox.vue';
import CheckCardPromoEligibility from './CheckCardPromoEligibility.vue';

export default {
  name: 'Subscribe',
  components: {
    CreditCardDetailsForm,
    RiseupButton: BaseUI.RiseupButton,
    CardNumberField,
    ExpirationField,
    CvvField,
    SocialId,
    PersonalInfoSummary,
    PromoNotificationBox,
    CheckCardPromoEligibility,
  },
  async created() {
    Segment.trackUserGot('SubscriptionCreditCardEntered');
  },
  destroyed() {
    PaymeInterface.teardown();
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
    back: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState('subscription', ['tokenizationError', 'loadingToken']),
    ...mapGetters('subscription', ['finalBillingDate']),
    firstBillingDayInMonth() {
      return moment(this.finalBillingDate).date();
    },
    firstBillingMonth() {
      return dates.getHebrewMonth(this.finalBillingDate);
    },
    firstBillingDateMessage() {
      return `נתחיל לחייב את הכרטיס ב-${this.firstBillingDayInMonth} ל${this.firstBillingMonth}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .credit-card {
    .image-container {
      position: relative;

      .image-intro {
        width: 100%;
      }
    }

    .form {
      @include responsive-padding;
      width: 100%;
      padding-top: 30px;
      padding-bottom: 33px;

      .sub-title {
        padding: 0px 0px 21px 28px;
        font-size: 20px;
        line-height: 1.3;
      }

      .card {
        @include card;

        .body {
          @include cashflow-card;
          padding-bottom: 15px;

          .promo-notification-box {
            margin-bottom: 25px;
          }

          .check-card-promo-eligibility {
            margin-top: 10px;
          }

          .amount-title {
            padding-top: 10px;
            font-size: 14px;
            line-height: 1;
          }

          .amount {
            font-size: 46px;
            font-weight: bold;
            padding: 11px 0 12px;
            line-height: 1;
          }
        }

        .separator {
          height: 1px;
          width: 100%;
          background: $riseup_gray_0;
        }
      }
    }

    .link {
      padding: 11px 0 34px 0;
      cursor: pointer;
      text-decoration: underline;
      color: $riseup_light_blue;
      text-align: center;
      font-weight: bold;
    }

    .button-container {
      display: flex;
      flex-direction: column;
      align-items: center;

      .riseup-button {
        width: 100%;
      }

      .disclaimer {
        margin-top: 9px;
        font-family: SimplerPro;
        font-size: 14px;
      }
    }

    .result-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 18px 16px;
      border-radius: 3px;
      background-color: rgba($riseup_gray_0, 0.4);

      .top {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-family: GretaSans;
        font-size: 20px;
        color: $riseup_coral;
        margin-left: 20px;

        .icon {
          margin-left: 11px;
        }

        .message {
          font-size: 20px;
          font-family: GretaSans;
          color: $riseup_coral;
        }
      }

      .cta {
        margin-top: 5px;
        font-family: SimplerPro;
        font-size: 16px;
        line-height: 1.5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/subscription/pages/CreditCard.vue